import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { Variant } from 'ctp-toll-domain';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariantSelector',
  props: {
  variants: {
    type: Array as PropType<Variant[]>,
    required: true
  }
},
  emits: ['variantSelection'],
  setup(__props, { emit }) {

const props = __props;




const variants = computed(() => props.variants);

const variantSelected = computed(() => props.variants[0]);

function onVariantSelection(event: Event) {
  emit('variantSelection', event);
}

return { __sfc: true,emit, props, variants, variantSelected, onVariantSelection }
}

})